// Migrated
<template>
  <div class="flex flex-wrap -mx-4">
    <div
      class="w-12/12 grow mb-4 md:mb-0 flex flex-col print-hidden px-4"
      :class="{ 'md:w-8/12': hasHighlights && hasMapPreview, 'md:w-6/12': hasHighlights && !hasMapPreview }"
    >
      <div class="mb-4 mb-print-0 pb-print-0 pb-print-6 my-print-0 order-2">
        <TripPreamble :trip="trip" />
      </div>

      <div
        v-if="trip.tags?.length && !$isSol"
        class="inline-block px-0 mb-3 print-hidden order-3"
      >
        <nuxt-link
          v-for="tag in trip.tags"
          :key="tag.category_url"
          class="bg-dirty-blue border border-transparent hover:border hover:border-blue-800 hover:bg-gray-50 font-secondary text-base font-semibold float-left text-blue-800 !mr-2 mb-2 px-4 text-nowrap py-1 rounded-[1.25rem]"
          :to="tag.category_url"
          :data-translation="tag?.rubrik_translationkey"
        >
          {{ tag.rubrik }}
        </nuxt-link>
      </div>

      <TripHighlights
        v-if="hasHighlights"
        :active-itinerary="activeItinerary"
        class="md:hidden mb-4 order-4"
      />

      <div
        v-if="hasMapPreview"
        class="size-full relative min-h-48 lg:min-h-72 md:min-h-80 order-3 lg:order-4 max-lg:mb-6"
      >
        <LazyMarkedMapPreview
          :show-see-whole-map-text="false"
          class="size-full absolute rounded-lg overflow-hidden"
          :trip="trip"
          :active-itinerary="activeItinerary"
          @open-map="$emit('openMap')"
        />
      </div>
    </div>

    <TripHighlights
      v-if="hasHighlights"
      :active-itinerary="activeItinerary"
      class="w-12/12 grow px-4 hidden md:flex"
      :class="hasMapPreview ? 'md:w-4/12' : 'md:w-6/12'"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  trip: {
    type: Object,
    required: true,
  },

  activeItinerary: {
    type: Object,
    required: true,
  },

  hasMapPreview: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['openMap'])

const hasHighlights = computed(() => props.trip.highlights?.length)
</script>
